module.exports = __webpack_public_path__ + "static/joomla-4-a9bea4aaf5a3aa32582390828d1963b9.png";